import { CompanyWireSettings as GqlCompanyWireSettings } from '@willow/graphql-iso/src/app';
import { CompanyWireSettings } from '@willow/types-iso';

export function getWireSettingsLabel(wireSettings: GqlCompanyWireSettings): string;
export function getWireSettingsLabel(wireSettings: CompanyWireSettings): string;
export function getWireSettingsLabel(wireSettings: GqlCompanyWireSettings | CompanyWireSettings): string {
  return `${wireSettings.accountName} (x${wireSettings.accountNumber.slice(-4)} ${wireSettings.bankName})`;
}
